export const defaultConsentId = 'default-project-consent-form';
export const consentIdSystem = 'http://lifeomic.com/fhir/consent-form-id';
